import { Controller } from "@hotwired/stimulus"

// Контроллер для строки form_list: автосабмит с debounce + icon feedback (spinner/checkmark/error).
export default class extends Controller {
  static targets = ["status"]
  static values = {
    delay: { type: Number, default: 800 },
    rowDomId: String
  }

  connect() {
    this.timeout = null
    this.abortController = null
  }

  scheduleSubmit(event) {
    // Не сабмитим при нажатии delete — это обрабатывается отдельно
    if (event && event.target && event.target.name === 'delete') return

    if (this.timeout) clearTimeout(this.timeout)

    this.timeout = setTimeout(() => {
      this.timeout = null
      this.doSubmit()
    }, this.delayValue)
  }

  confirmDelete(event) {
    const message = event.currentTarget.dataset.confirmMessage || 'Удалить запись?'
    if (!confirm(message)) {
      event.preventDefault()
      event.stopImmediatePropagation()
      return
    }
    // Если подтвердили — сабмитим форму напрямую с delete param
    this.showSpinner()
    this.element.requestSubmit(event.currentTarget)
  }

  async doSubmit() {
    // Abort previous request if still in-flight
    if (this.abortController) {
      this.abortController.abort()
    }

    this.abortController = new AbortController()
    this.showSpinner()

    const form = this.element
    const formData = new FormData(form)
    const url = form.action

    try {
      const response = await fetch(url, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
          'X-CSRF-Token': this.csrfToken
        },
        signal: this.abortController.signal
      })

      const data = await response.json()

      if (data.ok) {
        this.showCheckmark()
        // Если это был new_record, обновляем base_rec_id
        if (data.pk) {
          const hiddenPk = form.querySelector('input[name="base_rec_id"]')
          if (hiddenPk && !hiddenPk.value) {
            hiddenPk.value = data.pk
          }
        }
      } else {
        this.showError(data.errors)
      }
    } catch (err) {
      if (err.name === 'AbortError') return
      this.showError([err.message])
    } finally {
      this.abortController = null
    }
  }

  showSpinner() {
    if (!this.hasStatusTarget) return
    this.statusTarget.innerHTML = `
      <svg class="w-3.5 h-3.5 animate-spin text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
      </svg>
    `
  }

  showCheckmark() {
    if (!this.hasStatusTarget) return
    this.statusTarget.innerHTML = `
      <svg class="w-3.5 h-3.5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
      </svg>
    `
    // Fade out after 2s
    setTimeout(() => {
      if (this.hasStatusTarget) {
        this.statusTarget.innerHTML = ''
      }
    }, 2000)
  }

  showError(errors) {
    if (!this.hasStatusTarget) return
    const msg = Array.isArray(errors) ? errors.join('; ') : (errors || 'Ошибка')
    this.statusTarget.innerHTML = `
      <svg class="w-3.5 h-3.5 text-red-500 cursor-help" fill="none" stroke="currentColor" viewBox="0 0 24 24"
           title="${msg.replace(/"/g, '&quot;')}">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
      </svg>
    `
  }

  get csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.content : ''
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
      this.timeout = null
    }
    if (this.abortController) {
      this.abortController.abort()
      this.abortController = null
    }
  }
}
